import PropTypes from 'prop-types';
import React from 'react';
import { TabPane } from 'reactstrap';
import CheckItem from './checkItem';
const ChecksTab = ({
  checksArray
}) => /*#__PURE__*/React.createElement(TabPane, {
  tabId: "checks"
}, checksArray.length > 0 ? /*#__PURE__*/React.createElement("div", {
  className: "px-3"
}, checksArray.map(check => /*#__PURE__*/React.createElement(CheckItem, {
  key: check.id,
  checkId: check.id,
  check: check
}))) : /*#__PURE__*/React.createElement("div", {
  className: "text-center py-4"
}, /*#__PURE__*/React.createElement("p", {
  className: "text-muted mb-0"
}, "No checks available.")));
ChecksTab.propTypes = {
  checksArray: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string
  })).isRequired
};
export default ChecksTab;